export default __webpack_public_path__ + "static/media/testimonials-heading.ee7c9608.png";